import type { ATMModel } from '@atmvision/types'

// Maps each ATM model to the best-matching NCR Selfserv icon filename.
// Models without an exact image use the closest visual equivalent.
const ICON_MAP: Record<ATMModel, string | null> = {
  'NCR Selfserv 22':      'selfserv-22.png',
  'NCR Selfserv 22E':     'selfserv-22.png',   // same chassis
  'NCR Selfserv 23':      'selfserv-23.png',
  'NCR Selfserv 26':      'selfserv-25.png',   // no 26 icon — 25 is closest 2x
  'NCR Selfserv 27':      'selfserv-27.png',
  'NCR Selfserv 32':      'selfserv-38.png',   // no 32 icon — 38 is closest 3x
  'NCR Selfserv 38':      'selfserv-38.png',
  'NCR Selfserv 62':      'selfserv-62.png',
  'NCR Selfserv 82':      'selfserv-82.png',
  'NCR Selfserv 84':      'selfserv-84.png',
  'NCR Selfserv 88':      'selfserv-88.png',
  'NCR Selfserv 6682 FA': 'selfserv-64.png',   // recycler/modular — 64 is closest
  'NCR Selfserv 6682 RA': 'selfserv-64.png',
  'GRG H22VL':            null,                // no NCR image available
}

const INFOCARD_MAP: Record<ATMModel, string | null> = {
  'NCR Selfserv 22':      'selfserv-22-variation-a-sketch.png',
  'NCR Selfserv 22E':     'selfserv-22-variation-a-sketch.png',
  'NCR Selfserv 23':      'selfserv-23-variation-a-sketch.png',
  'NCR Selfserv 26':      'selfserv-25-variation-a-sketch.png',
  'NCR Selfserv 27':      'selfserv-27-variation-a-sketch.png',
  'NCR Selfserv 32':      'selfserv-38-variation-a-sketch.png',
  'NCR Selfserv 38':      'selfserv-38-variation-a-sketch.png',
  'NCR Selfserv 62':      'selfserv-62-variation-a-sketch.png',
  'NCR Selfserv 82':      'selfserv-82-variation-a-sketch.png',
  'NCR Selfserv 84':      'selfserv-84-variation-a-sketch 2.png',
  'NCR Selfserv 88':      'selfserv-88-variation-a-sketch 2.png',
  'NCR Selfserv 6682 FA': 'selfserv-64-variation-a-sketch.png',
  'NCR Selfserv 6682 RA': 'selfserv-64-variation-a-sketch.png',
  'GRG H22VL':            null,
}

const GENERIC = '/atm-models/atm-generic.png'

export function modelIcon(model: ATMModel): string {
  const file = ICON_MAP[model]
  return file ? `/atm-models/icons/${file}` : GENERIC
}

export function modelInfocard(model: ATMModel): string {
  const file = INFOCARD_MAP[model]
  return file ? `/atm-models/infocard/${file}` : GENERIC
}
